import request from 'utils/http.js'
import { i18n } from 'utils/i18n/index.js'

//登录
export function login(data) {
	data.clientId = 'e5cd7e4891bf95d1d19206ce24a7b32e'
	data.grantType = data.grantType || 'password'
	return request({
		url: '/auth/liberty/login',
		headers: {
			isToken: false,
		},
		method: 'post',
		data,
	})
}
//注册
export function register(data) {
	data.clientId = 'e5cd7e4891bf95d1d19206ce24a7b32e'
	return request({
		url: '/auth/liberty/register',
		headers: {
			isToken: false,
		},
		method: 'post',
		data,
	})
}
// 获取用户详情
export function getUserDetail() {
	return request({
		url: '/enterprise/certificate/certificate/portal/info',
		method: 'get',
	})
}
// 提交认证信息
export function submitAuthentication(data) {
	return request({
		url: '/enterprise/certificate/certificate/portal/certificate',
		method: 'post',
		data,
	})
}
// 查询提交记录
export function submitRecordList() {
	return request({
		url: '/enterprise/certificate/certificate/portal/info',
		method: 'get'
	})
}
// 供应商查询产品列表
export function productList(params) {
	return request({
		url: '/erp/product/portal/list/ent',
		method: 'get',
		params,
	})
}
// 供应商新增产品列表
export function addProduct(data) {
	return request({
		url: '/erp/product/portal/add',
		method: 'post',
		data,
	})
}

// 删除产品
export function deleteProduct(data) {
	return request({
		url: '/erp/product/portal/'+data,
		method: 'delete',
	})
}
// 产品详情
export function productDetail(id) {
	return request({
		url: '/erp/product/portal/'+id,
		method: 'get',
	})
}
// 修改产品信息
export function updateProduct(data) {
	return request({
		url: '/erp/product/portal/edit',
		method: 'post',
		data,
	})
}
// 发起审核
export function submitAudit(data) {
	return request({
		url: '/erp/productAuditRecord/portal/initiateAudit',
		method: 'post',
		data,
	})
}
// 产品上下架
export function productStatus(data) {
	return request({
		url: '/erp/product/shelfStatus',
		method: 'post',
		data,
	})
}
// 产品分类
export function productCategoryList(isLocale) {
	return request({
		url: '/erp/category/portal/treeSelectAll',
		method: 'get',
		headers: {
			'content-language': isLocale
		}
	})
}

// 字典
export function dictApi(params) {
	return request({
		url: '/system/dict/data/portal/type/'+params,
		method: 'get'
	})
}

// 新增产品
export function addProductApi(data) {
	return request({
		url: '/erp/product/portal/add',
		method: 'post',
		data,
	})
}
// oss查询图片地址
export function ossApi(params) {
	return request({
		url: '/resource/oss/portal/listByIds/'+params,
		method: 'get',
	})
}
// 供应大厅列表查询
export function supplyHallList(params) {
	return request({
		url: '/erp/product/portal/list/r',
		method: 'get',
		params,
	})
}
// 新闻中心列表
export function newsListApi(params) {
	return request({
		url: '/news/centreInfo/portal/list',
		method: 'get',
		params
	})
}
// 新闻中心详情
export function newsDetailApi(id) {
	return request({
		url: '/news/centreInfo/portal/'+id,
		method: 'get',
	})
}
// 产品咨询
export function productConsultation(params) {
	return request({
		url: '/erp/proConsultRecord/portal/add',
		method: 'get',
		params,
	})
}
// 产品咨询
export function productConsultation2(params) {
	return request({
		url: '/erp/publishPurchaseRequirements/portal/editShowEnterprise/consult',
		method: 'get',
		params,
	})
}

// 收藏商品
export function productCollection(params) {
	return request({
		url: '/erp/collect/portal/product/'+params,
		method: 'get',
	})
}
//取消收藏
export function productCollectionCancel(params) {
	return request({
		url: '/erp/collect/portal/cancelProduct/'+params,
		method: 'get',
	})
}
// 添加购物车
export function productShop(productId) {
	return request({
		url: '/erp/cartUnsubmitted/portal/cart/'+productId,
		method: 'get',
	})
}
//取消购物车
export function productShopCancel(productId) {
	return request({
		url: '/erp/cartUnsubmitted/portal/cancelCart/'+productId,
		method: 'get',
	})
}
//购物车-提交购物车
export function productShopSubmit() {
	return request({
	  url: '/erp/cartUnsubmitted/portal/submitted/cart',
	  method: 'post',
	})
  }
  //购物车-记录详情
  export function productSubmitDetail(params) {
	return request({
	  url: '/erp/cartSubmittedDetail/portal/submitted/detail/list',
	  method: 'get',
	  params,
	})
  }
// 我的产品统计
export function productStatistics(params) {
	return request({
		url: '/erp/product/portal/status/count',
		method: 'get',
		params,
	})
}
// 修改个人信息
export function personalInformationApi(data) {
	return request({
		url: '/system/user/profile/updateProfilePortal',
		method: 'post',
		data,
	})
}
// 修改用户头像
export function personalInformationAvatarApi(data) {
	return request({
		url: '/system/user/profile/avatar',
		method: 'post',
		data,
	})
}
// 用户查看收藏列表
export function productCollectionList(params) {
	return request({
		url: '/erp/collect/portal/list',
		method: 'get',
		params,
	})
}
// 用户查看未提交购物车列表
export function productShopList(params) {
	return request({
		url: '/erp/cartUnsubmitted/portal/unsubmitted/cart/list',
		method: 'get',
		params,
	})
}
// 用户查看已提交购物车列表
export function productSubmitShopList(params) {
	return request({
		url: '/erp/cartSubmitted/portal/submitted/cart/list',
		method: 'get',
		params,
	})
}

// ———————————————————————————————————— 采购商需求接口 ————————————————————————————————————
// 新增采购需求
export function addPurchaseDemand(data) {
	return request({
		url: '/erp/publishPurchaseRequirements/portal/add',
		method: 'post',
		data,
	})
}
//修改采购需求
export function updatePurchaseDemand(data) {
	return request({
		url: '/erp/publishPurchaseRequirements/portal/edit',
		method: 'post',
		data,
	})
}
//删除采购需求
export function deletePurchaseDemand(data) {
	return request({
		url: '/erp/publishPurchaseRequirements/portal/'+data,
		method: 'delete',
	})
}
// 查询采购需求列表
export function purchaseDemandList(params) {
	return request({
		url: '/erp/publishPurchaseRequirements/portal/list',
		method: 'get',
		params,
	})
}
// 采购需求详情
export function purchaseDemandDetail(id) {
	return request({
		url: '/erp/publishPurchaseRequirements/portal/'+id,
		method: 'get',
	})
}
// 发起审核
export function purchaseDemandAudit(data) {
	return request({
		url: '/erp/publishPurchaseRequirements/initiateAudit/'+data,
		method: 'post',
	})
}
// 统计采购需求
export function purchaseDemandStatistics(params) {
	return request({
		url: '/erp/publishPurchaseRequirements/portal/statusStatistic',
		method: 'get',
		params,
	})
}
// 查询所有采购需求
export function purchaseDemandAllList(params) {
	return request({
		url: '/erp/publishPurchaseRequirements/portal/allList',
		method: 'get',
		params,
	})
}
// 查询本月订单总额
export function purchaseDemandOrderTotal(params) {
	return request({
		url: '/erp/order/getMyOrderTotalAmount',
		method: 'get',
		params,
	})
}
//订单数量统计
export function purchaseDemandOrderCount(params) {
	return request({
		url: '/erp/order/getMyOrderStatistics',
		method: 'get',
		params,
	})
}



// ———————————————————————————————————— 暂时废弃接口 ————————————————————————————————————
// 供货商绑定产品
export function bindProduct(data) {
	return request({
		url: '/erp/proEntRelation/addPortal',
		method: 'post',
		data,
	})
}
//供货商解绑商品
export function unbindProduct(data) {
	return request({
		url: '/erp/proEntRelation/removePortal/'+data,
		method: 'post',
	})
}
// 供货商绑定用产品列表
export function bindProductList(params) {
	return request({
		url: '/erp/product/portal/list/r',
		method: 'get',
		params,
	})
}
/** 数据字典 */
// export function dictApi(val) {
// 	return request({
// 		url: '/system/dict/data/mobile/list?dictType=' + val,
// 		method: 'get',
// 	})
// }

// ———————————————————————————————————— 用户相关接口 —————————————————————————————————
/** 注册 */
export function registerApi(data) {
	return request({
		url: '/api/register',
		headers: {
			isToken: false,
		},
		method: 'post',
		data,
	})
}
/** 用户登录 */
export function loginApi(data) {
	return request({
		url: '/api/login',
		headers: {
			isToken: false,
		},
		method: 'post',
		data,
	})
}
/** 获取用户信息 */
export function getUserInfo() {
	return request({
		url: '/api/user/getInfo',
		method: 'get',
	})
}
/** 修改用户信息 */
export function editUserInfo(data) {
	return request({
		url: '/api/user/updateInfo',
		method: 'post',
		data: data
	})
}
/** 获取验证码 */
export function getAuthCode() {
	return request({
		url: '/captchaImage',
		headers: {
			isToken: false,
		},
		method: 'get',
		timeout: 20000,
	})
}
// ————————————————————————————————————    —————————————————————————————————
// 新-解决方案
export function schemeListApi(params) {
	return request({
		url: '/erp/schemeType/portal/treeSelectInfo',
		method: 'get',
		params
	})
}

// 新增IDEF 2025展会预约登记
export function addAppointmentRecord(data) {
	return request({
		url: '/erp/meetingRegistration',
		method: 'post',
		data,
	})
}
